import axios from '../axiosInstance';

export async function getFormulations({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/Formulations/getFormulations', { params: { search, pageSize, lastId }, signal });
    return data; // { items, lastId, hasMore }
}
